import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {ShellComponent} from './shell/shell.component';
import {RisClientsStateComponent} from './ris-clients-state/ris-clients-state.component';
import {RisServersStateComponent} from './ris-servers-state/ris-servers-state.component';
import {RisMonitoringScriptsComponent} from './ris-monitoring-scripts/ris-monitoring-scripts.component';
import {RisMonitoringScriptsResultsComponent} from './ris-monitoring-scripts/ris-monitoring-scripts-results/ris-monitoring-scripts-results.component';
import {LogManagerComponent} from './log-manager/log-manager.component';
import {UploadLogFilesComponent} from './upload-log-files/upload-log-files.component';
import {LoginComponent} from './login/login.component';
import {AuthGuard} from './auth/auth.guard.service';
import {AppConfig}  from './app-config/app-config';
import {AppConfigService}  from './app-config/app-config.service';
import {RisWebClientsStateComponent} from "./ris-web-clients-state/ris-web-clients-state.component";
import {PatientPortalComponent} from "./patient-portal/patient-portal.component";

const defaultRoute = 'login';

const ROUTES: Routes = [
    { path: '',
      pathMatch: 'full',
      redirectTo: defaultRoute
    },
    { path: 'login', component: LoginComponent, resolve: { appConfig: AppConfig } },
    {
        path: 'shell',
        component: ShellComponent,
        resolve: { appConfig: AppConfig },
        canActivate: [AuthGuard],
        loadChildren: () => import("../app/shell/shell.module").then(mod => mod.ShellModule),
    },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(ROUTES)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        AppConfig,
        AppConfigService
    ]
})
export class APPRoutingModule { }
